import { Button } from '../ui/button';

export interface RejectModalProps {
  isOpen: boolean;
  clientName?: string;
  rejectReason: string;
  onRejectReasonChange: (value: string) => void;
  onCancel: () => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
}

const RejectModal = ({
  isOpen,
  clientName,
  rejectReason,
  onRejectReasonChange,
  onCancel,
  onSubmit,
  isSubmitting = false,
}: RejectModalProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h3 className="text-lg font-semibold mb-4">Reject Reason</h3>
        <p className="text-sm text-gray-600 mb-4">
          Please provide a reason for rejecting {clientName}
          &apos;s application.
        </p>
        <textarea
          value={rejectReason}
          onChange={e => onRejectReasonChange(e.target.value)}
          placeholder="Enter rejection reason..."
          className="w-full p-3 border border-gray-300 rounded-md resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          rows={4}
        />
        <div className="flex justify-end space-x-3 mt-4">
          <Button variant="outline" onClick={onCancel} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            onClick={onSubmit}
            disabled={!rejectReason.trim() || isSubmitting}
            className="bg-red-600 hover:bg-red-700"
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

RejectModal.displayName = 'RejectModal';

export default RejectModal;
